import React from 'react';
import { useMsal } from "@azure/msal-react";

const Login = (props) => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      // Login using MSAL
      const result = await instance.loginPopup({
        scopes: ["openid", "profile", "email"],
      });
      
      // Set the authenticated account
      props.onAccountChange(result.account);
    } catch (e) {
      console.error(e);
    }
  };
  

  return (
    <div>
      <h2>Login</h2>
      <button onClick={handleLogin}>Sign In</button>
    </div>
  );
};

export default Login;
